import React, { PropsWithChildren } from 'react';

import InlineInput from '@/components/InlineInput';
import { FormField } from '@/components/ui/form';
import MaskedInput from '@/components/MaskedInput';

interface IProps extends PropsWithChildren {
  control: any;
  isLoading: boolean;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

const ResponsibleFormStepView: React.FC<IProps> = ({
  control,
  isLoading,
  onSubmit,
  children,
}) => (
  <form onSubmit={onSubmit}>
    <div className="grid gap-4 py-4">
      <FormField
        control={control}
        name="responsibleName"
        render={({ field }) => (
          <InlineInput title="Responsável" disabled={isLoading} {...field} />
        )}
      />
      <FormField
        control={control}
        name="responsibleEmail"
        render={({ field }) => (
          <InlineInput
            title="Email de contato"
            disabled={isLoading}
            {...field}
          />
        )}
      />
      <FormField
        control={control}
        name="responsiblePhone"
        render={({ field }) => (
          <InlineInput
            title="Telefone de contato"
            disabled={isLoading}
            as={MaskedInput}
            maskOptions={{
              mask: '(00) 00000-0000',
            }}
            {...field}
          />
        )}
      />
    </div>
    {children}
  </form>
);

export default ResponsibleFormStepView;
